<template>
  <base-container :isLoading="loading" style="padding: 5px 5px">
    <el-card>
      <el-row>
        <el-col :span="8">
          <el-input
            placeholder="请输入患者id"
            v-model="cardNo"
            clearable
            size="mini"
          >
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-row type="flex" class="row-bg" style="margin-left: 20px">
            <el-select size="mini" v-model="date" placeholder="请选择时间">
              <el-option
                v-for="item in filterTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-button
            size="mini"
            type="primary"
            @click="selectPatient"
            icon="el-icon-search"
            class="margin-h5"
          >
            查询
          </el-button>
        </el-col>
      </el-row>
      <el-row style="margin: 5px 0 0 3px">
        <el-col :span="8">
          姓名： <span style="font-weight: bolder">{{ patient.name }}</span>
        </el-col>
        <el-col :span="8">
          性别： <span style="font-weight: bolder">{{ patient.gender }}</span>
        </el-col>
        <el-col :span="8">
          出生日期：
          <span style="font-weight: bolder">{{ patient.birthday }}</span>
        </el-col>
      </el-row>
    </el-card>
    <div class="margin-v10" v-for="(bill, i) in bookedData" :key="i">
      <artisan-group>
        <template #header>
          <el-row type="flex" justify="space-between">
            <span>申请单号：{{ bill.id }}</span>
            <span>{{ getTypeLabel(bill.clinicType) }}</span>
            <span>开单时间：{{ bill.billTime }}</span>
          </el-row>
        </template>
        <el-descriptions>
          <el-descriptions-item label="检查项目">
            <el-tag size="small">{{ bill.projectName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="申请科室">
            {{ bill.applyDeptName }}
          </el-descriptions-item>
          <el-descriptions-item label="执行科室">
            {{ bill.exeDeptName }}
          </el-descriptions-item>
          <el-descriptions-item label="开单医生">
            {{ bill.doctorName }}
          </el-descriptions-item>
        </el-descriptions>
        <el-row class="border-top-gray padding-v7" type="flex" align="middle">
          <div style="position: absolute; right: 0; bottom: 0">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-setting"
              class="margin-h5"
              @click="reviseReserve(bill, i)"
            >
              预约
            </el-button>
          </div>
        </el-row>
      </artisan-group>
    </div>

    <artisan-drawer
      title="推荐时间"
      :visible.sync="isShow"
      :isLoading="isLoading"
      size="40%"
      direction="right"
    >
      <apply-reserve
        v-if="isShow"
        ref="recommend"
        :deptId="bill.exeDeptId"
      ></apply-reserve>
      <template #footer>
        <el-button type="primary" size="mini" @click="confirmApply()">
          确认预约
        </el-button>
      </template>
    </artisan-drawer>
  </base-container>
</template>

<script>
import constant from "@/config/constant";
import { loadEnums } from "@/api/sys/dicType";
import moment from "moment";
import { getInspectApply, reserve } from "@/api/jy/apply";
import { getPatientInfo } from "@/api/basis/patient";
import ApplyReserve from "./ApplyReserve.vue";
export default {
  components: { ApplyReserve },
  data() {
    return {
      isShow: false,
      isLoading: false,
      loading: false,
      bookedData: [],
      res: {},
      bill: {},
      cardNo: "",
      filterTypes: [
        {
          label: "今天",
          value: "day",
          time: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        },
        {
          label: "近一周",
          value: "week",
          time: [
            moment().subtract(1, "week").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "一个月",
          value: "month",
          time: [
            moment().subtract(1, "month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "三个月",
          value: "quarter",
          time: [
            moment().subtract(3, "month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "近半年",
          value: "halfyear",
          time: [
            moment().subtract(6, "month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: "近一年",
          value: "year",
          time: [
            moment().subtract(1, "year").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
      ],
      date: "day",
      type: "patientId",
      patient: {
        id: "",
        name: "",
        gender: "",
        birthday: "",
      },
      data: [],
      tableData: [],
      index: -1,
    };
  },
  created() {
    loadEnums("ClinicTypeOption").then((res) => {
      this.dic = res.data.data;
    });
  },
  methods: {
    reviseReserve(row, i) {
      this.index = i;
      Object.assign(row, this.res[row.projectId]);
      this.bill = row;
      this.isShow = true;
    },
    getStatusColor(value) {
      let option = constant.JcBillStatusOption.find((c) => c.value == value);
      if (option) return option.color;
      return "";
    },
    getStatusLabel(value) {
      let option = constant.JcBillStatusOption.find((c) => c.value == value);
      if (option) return option.text;
      return "";
    },
    getTypeLabel(value) {
      if (this.dic.ClinicTypeOption) {
        let arr = this.dic.ClinicTypeOption.find((s) => s.value == value);
        if (arr) {
          return arr.label;
        }
      }
      return "";
    },
    confirmApply() {
      let periodData = this.$refs.recommend.getData();
      if (periodData == "") {
        this.$message({
          message: "请选择大于当前时间的时间段！",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否预约", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isShow = false;
        this.loading = true;
        let data = Object.assign({}, this.bill);
        data.patientInfo = this.patient;
        data.hosId = "01";
        data.applyNo = this.bill.id;
        Object.assign(data, periodData);
        data.scheduleId = periodData.id;
        reserve(data)
          .then((res) => {
            this.$message({
              message: "预约成功！",
              type: "success",
            });
            this.bookedData.splice(this.index, 1);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    selectPatient() {
      if (this.cardNo == "") {
        this.$message({
          message: this.placeholder,
          type: "warning",
        });
        return;
      }
      if (this.date == null) {
        this.$message({
          message: "请选择时间！",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      getPatientInfo(this.cardNo)
        .then((res) => {
          this.patient = res.data.data;
          let times = this.filterTypes.find((c) => c.value == this.date).time;
          return getInspectApply(this.cardNo, times[0], times[1]);
        })
        .then((res) => {
          this.bookedData = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>